export const enum ModeActionType {
  SET_CURRENT_SERVETYPE = 'SET_CURRENT_SERVETYPE',
  SET_PROVIDE_SERVETYPE = 'SET_PROVIDE_SERVETYPE',
  SET_PROJECT_NAME = 'SET_PROJECT_NAME',
  SET_CUSTOMIZED_SERVETYPE = 'SET_CUSTOMIZED_SERVETYPE',
}
